// extracted by mini-css-extract-plugin
module.exports = {"productPrice":"_2n3nU","secondary":"_3Xpnx","crossed":"_1NUdd","basePrice":"_3PAzb","priceBreakdown":"DUo23"};